export default __webpack_public_path__ + "static/media/CK.b110327f.svg";